// 充电桩信息
const queryChargePileReportDataURL = `/gateway/hc-connect/data/queryChargePileReportData`;

export { queryChargePileReportDataURL };
